import { TabPanel, TabView } from 'primereact/tabview';
import {CommonDialog} from '../common/CommonDialog';
import { Form } from '../common/Form';
import { useEffect, useRef, useState } from 'react';
import CatService from '../../service/CatService';
import { ProcViewer} from '../common/ProcViewer';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

export function ImportProgDialog({visible,onClose})
{
    const {t} = useTranslation();
    const [progs,setProgs] = useState([]);
    const [proc,setProc] = useState(null);
    const [formData,setFormData] = useState(null);
    const msgs = useRef(null);

    const onChange=(form)=>{
        setFormData(form);
    }
    const onProcOK=(proc)=>{
        console.log("proc ended:"+JSON.stringify(proc));
        msgs.current.show([{ sticky: true, severity: 'success', summary: 'Program loaded', detail: 'Program loaded', closable: false }]);        
        //onOK();
    }
    const showError=(err)=>{
        msgs.current.show([{ sticky: true, severity: 'error', summary: t('error'), detail: t('@error.'+err), closable: false }]); 
    }

    const _onOK=()=>{
        CatService.importProg(formData.progCode).then((ret)=>{
            setProc(ret);
        }).catch((err)=>{showError(err.response.data.message)});
    }
    const _onClose=()=>{
        onClose();
    }
    const _loadProgs=()=>{
        CatService.getProgs().then((ret)=>{
            setProgs(ret);
        }).catch((err)=>{showError(err.response.data.message)});
    }
    useEffect(()=>{
        _loadProgs();
    },[]);
    return(
        <>
        <CommonDialog header={t('Import program')} visible={visible} onClose={_onClose}>
            <div style={{width:'450px',height:'300px'}}>
            <ProcViewer service={CatService} procId={proc!=undefined?proc.id:-1} onOK={onProcOK}></ProcViewer>
            <Messages ref={msgs} />
            <div className={proc!=null?'hidden':''}>
                <Form id="importProg" formData={formData} columns="1" onChange={onChange} fields={[
                    {id:"progCode",ftype:"dropdown",field:"progCode",label:t("Program"),options:progs,optionLabel:"name",optionValue:'code'},
                ]}/>
                <Button label="Load program" onClick={_onOK} severity='primary'/>
            </div>
            </div>
        </CommonDialog>
        </>
    )
}